import { render, staticRenderFns } from "./HistoryLine.vue?vue&type=template&id=620c4de7"
import script from "./HistoryLine.vue?vue&type=script&lang=js"
export * from "./HistoryLine.vue?vue&type=script&lang=js"
import style0 from "./HistoryLine.vue?vue&type=style&index=0&id=620c4de7&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports